'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.parseQueryToData = parseQueryToData;
exports.encodeBase64 = encodeBase64;
exports.decodeBase64 = decodeBase64;
exports.isMultiTier = isMultiTier;
exports.isMultiTierSupportForeignPrices = isMultiTierSupportForeignPrices;
exports.isMultiTierSupportForeignCurrency = isMultiTierSupportForeignCurrency;
exports.parseDataToQuery = parseDataToQuery;
exports.getAdditionalOptionsList = getAdditionalOptionsList;
exports.getAddOptObj = getAddOptObj;
exports.omitOptionByCurrency = omitOptionByCurrency;
exports.genOptionsFromKey = genOptionsFromKey;
exports.genOptionsFromBooking = genOptionsFromBooking;
exports.plusEight = plusEight;
exports.getHotelDestination = getHotelDestination;
exports.getTicketQuestions = getTicketQuestions;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _trip = require('./trip');

var _countries = require('utils/countries');

var _helpers = require('utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
function parseQueryToData(query) {
  var data = {
    promo: null,
    trip: null,
    date: null,
    quantity: null,
    multi_tier_quantity: null,
    requestType: 'message',
    device: 'mobile'
  };
  if (query.promo) data.promo = query.promo;
  if (query.trip) data.trip = query.trip;
  if (query.date) data.date = (0, _momentTimezone2.default)(query.date, 'DD-MM-YYYY').toISOString();
  data.tier = -1;
  if (query.tier) data.tier = parseInt(query.tier, 10);
  if (query.subTiers) data.subTiers = query.subTiers.split(',').map(function (s) {
    return parseInt(s, 10);
  });
  if (query.quantity) data.quantity = parseInt(query.quantity, 10);
  if (query.deliveryLocation) data.deliveryLocation = query.deliveryLocation;
  if (query.requestType) data.requestType = query.requestType;
  if (query.acceptSwap) data.acceptSwap = query.acceptSwap;
  if (query.device) data.device = query.device;
  if (query.options) {
    data.options = {};
    var options = query.options.split(',');
    options.forEach(function (option) {
      var _option$split = option.split(':'),
          _option$split2 = (0, _slicedToArray3.default)(_option$split, 2),
          key = _option$split2[0],
          value = _option$split2[1];

      data.options[key] = parseInt(value, 10);
    });
  }
  if (query.cust_mobile) data.mobile = query.cust_mobile;
  if (query.cust_firstname) data.firstname = query.cust_firstname;
  if (query.cust_lastname) data.lastname = query.cust_lastname;
  if (query.cust_email) data.email = query.cust_email;
  if (query.cust_country) data.country = query.cust_country && _countries.countryMap[query.cust_country] || '';
  if (query.cust_hotel) data.hotel = query.cust_hotel;
  return data;
}

// ucs-2 string to base64 encoded ascii
function encodeBase64() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (window) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }
  return str;
}

// base64 encoded ascii to ucs-2 string
function decodeBase64() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (window) {
    return decodeURIComponent(escape(window.atob(str)));
  }
  return str;
}

function isMultiTier(trip) {
  if (trip.multi_tier_prices && trip.multi_tier_prices.length > 0) return true;
  return false;
}

function isMultiTierSupportForeignPrices(trip) {
  if (trip.foreign_multi_tier_prices) return true;
  return false;
}

function isMultiTierSupportForeignCurrency(trip, currency) {
  if (isMultiTierSupportForeignPrices(trip) && trip.foreign_multi_tier_prices[currency]) return true;
  return false;
}

function parseDataToQuery(data) {
  var base = '/booking/new';
  var query = [];
  if (data.step && data.step !== 1) query.push('step=' + data.step);
  if (data.trip && data.trip.slug) query.push('trip=' + data.trip.slug);
  if (data.date) query.push('date=' + (0, _momentTimezone2.default)(data.date).format('DD-MM-YYYY'));
  if (data.trip && isMultiTier(data.trip) && data.tier >= 0 && data.subTiers) {
    query.push('tier=' + data.tier + '&subTiers=' + data.subTiers.join(','));
  } else if (data.quantity) query.push('quantity=' + data.quantity);
  if (data.requestType) query.push('requestType=' + data.requestType);
  if (data.device) query.push('device=' + data.device);
  if (data.selectedOptions) {
    var keyOptions = data.selectedOptions.reduce(function (acc, cur) {
      if (cur.quantity_type === 'select') return (0, _extends6.default)({}, acc, (0, _defineProperty3.default)({}, cur.key, cur.option_data));
      if (cur.quantity > 0) return (0, _extends6.default)({}, acc, (0, _defineProperty3.default)({}, cur.key, cur.quantity));
      return acc;
    }, {});
    query.push('options=' + (0, _trip.decorateAdditionalOptionsString)(keyOptions));
  }
  if (data.lastMobile) query.push('cust_mobile=' + data.lastMobile);
  if (data.firstName && data.lastName) {
    query.push('cust_firstname=' + data.firstName);
    query.push('cust_lastname=' + data.lastName);
  }
  if (data.email) query.push('cust_email=' + data.email);
  if (data.lastCountry) query.push('cust_country=' + _lodash2.default.invert(_countries.countryMap)[data.lastCountry]);
  if (query.length > 0) {
    base += '?' + query.join('&');
  }
  return base;
}

function getAdditionalOptionsList(trip, currency) {
  // wont generate option that's not available in trip
  if (!trip.additional_options) return [];
  return trip.additional_options.filter(function (option) {
    return option.currency === currency;
  });
}

function getAddOptObj() {
  var selectedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currency = arguments[1];
  var key = arguments[2];

  return _lodash2.default.find(selectedOptions, { key: key, currency: currency }) || _lodash2.default.find(selectedOptions, { key: key });
}

function omitOptionByCurrency(trip, currency) {
  if (!trip.additional_options) return [];
  var matchCurrencyOptions = trip.additional_options.filter(function (o) {
    return o.currency === currency;
  });
  trip.additional_options.map(function (o) {
    if (!_lodash2.default.find(matchCurrencyOptions, { key: o.key })) {
      matchCurrencyOptions.push(o);
    }
  });
  return matchCurrencyOptions;
}

function genOptionsFromKey(trip, currency) {
  var keyOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!trip.additional_options) return [];
  return omitOptionByCurrency(trip, currency).map(function (option) {
    var quantity = 0;
    // if (option.key === 'time_slot') {
    //   quantity = 1;
    //   return { ...option, option_data: keyOptions[option.key] || option.option_data[0] };
    // }
    if ((0, _helpers.isNumber)(keyOptions[option.key])) quantity = keyOptions[option.key];else if ((0, _helpers.isNumber)(option.quantity)) quantity = option.quantity;
    return (0, _extends6.default)({}, option, { quantity: quantity });
  });
}

function genOptionsFromBooking(trip, currency, selectedOptions) {
  if (!selectedOptions) return [];
  var keyOptions = selectedOptions.reduce(function (acc, cur) {
    return (0, _extends6.default)({}, acc, (0, _defineProperty3.default)({}, cur.key, cur.quantity));
  }, {});
  return genOptionsFromKey(trip, currency, keyOptions);
}

function plusEight(time) {
  var pad = '00';
  var hr = ((parseInt(time.slice(0, 2), 10) + 8) % 24).toString();
  return pad.substring(0, pad.length - hr.length) + hr + time.slice(2);
}

function getHotelDestination(trip) {
  var isSpa = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isSpa) {
    if (trip.meeting_point_locations.includes('Bangkok')) {
      return 'Bangkok';
    } else if (trip.meeting_point_locations.includes('Chiang Mai')) {
      return 'Chiang Mai';
    }
    return trip.destination_location;
  }
  if (trip.destination_location !== 'Bangkok' && trip.intermediate_locations.find(function (loc) {
    return loc === 'Bangkok';
  })) {
    return 'Bangkok/' + trip.destination_location;
  }
  return trip.destination_location;
}

function getTicketQuestions(multiTierQuantity, activeTier) {
  var tier = multiTierQuantity.find(function (q) {
    return q.tier === activeTier;
  });
  return tier && _lodash2.default.uniqBy(tier.sub_tiers.reduce(function (prev, curr) {
    return curr.globaltix_questions ? [].concat((0, _toConsumableArray3.default)(prev), (0, _toConsumableArray3.default)(curr.globaltix_questions)) : prev;
  }, []), 'id') || [];
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/payment.js
// module id = 73
// module chunks = 47